var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.6663 6V10.9733C14.6663 12.5 13.4263 13.7333 11.8997 13.7333H4.09967C2.57301 13.7333 1.33301 12.5 1.33301 10.9733V6H14.6663Z",
    fill: "#AEBFD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 5.0266V5.99993H1.33301V5.0266C1.33301 3.49993 2.57301 2.2666 4.09967 2.2666H11.8997C13.4263 2.2666 14.6663 3.49993 14.6663 5.0266Z",
    fill: "#AEBFD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 11.5H4C3.72667 11.5 3.5 11.2733 3.5 11C3.5 10.7267 3.72667 10.5 4 10.5H5.33333C5.60667 10.5 5.83333 10.7267 5.83333 11C5.83333 11.2733 5.60667 11.5 5.33333 11.5Z",
    fill: "#AEBFD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 11.5H7C6.72667 11.5 6.5 11.2733 6.5 11C6.5 10.7267 6.72667 10.5 7 10.5H9.66667C9.94 10.5 10.1667 10.7267 10.1667 11C10.1667 11.2733 9.94 11.5 9.66667 11.5Z",
    fill: "#AEBFD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.b8a4f787.svg";
export { ForwardRef as ReactComponent };